/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from 'react-query';
import { API } from 'api';
import { isUndefinedOrNullOrEmpty } from 'common';
import { approvalBulkUploadTypesData } from 'views/EmployerManagement/shared/Settings&ConfigForm/data';
import { ISharedEmployerInfoOrEmployerRequestInfoDataOutput } from '../shared';

interface IEmployerInfoResponse {
  data: {
    eid: string;
    name?: string;
    companyName: string;
    companyLogo: string;
    // SUNSET FEATURE 2026-01-08: Company Description (Remark)
    // companyDescription: string;
    companyInformation: {
      bnmCategory: string;
      bnmSubCategory: string;
      businessLicenseExpiryDate: string;
      // SUNSET FEATURE 2026-01-08: Company Description (Remark)
      // companyDescription: string;
      companyRegistrationNo: {
        new: string;
        old: string;
      };
      employerType: string;
      // SUNSET FEATURE 2026-01-08: GST Registration No
      // gstRegistrationNo: string;
      owner: {
        name: string;
        ic: string;
      }[];
      inAppCompanyLogo?: boolean;
      foreignExchangeEnabled?: boolean;
      foreignExchangeProfile?: {
        walletCurrency: string;
        baseCountry: string;
      };
    };
    contactInformation: {
      email: string;
      mailing: {
        addressLine1: string;
        addressLine2: string;
        city: string;
        contactPerson: string;
        country: string;
        postalCode: string;
        state: string;
      };
      mobile: string;
      secondaryEmail: string;
      website: string;
      // SUNSET FEATURE 2026-01-08: Work Phone
      // workPhone: string;
    };
    attachments: {
      companyLogo: string;
      // SUNSET FEATURE 2026-01-08: HLB Application Form, Audited Financial Statements, Letter of Authorisation
      // hlbApplicationForm: {
      //   file: string;
      //   name: string;
      // };
      // auditedFinancialStatements: {
      //   file: string;
      //   name: string;
      // };
      businessRegistrationDocument: {
        file: string;
        name: string;
      };
      // letterOfAuthorisation: {
      //   file: string;
      //   name: string;
      // };
      signedAgreement: {
        file: string;
        name: string;
      };
      ctosReport: {
        file: string;
        name: string;
      };
      others: {
        file: string;
        name: string;
      };
    };
    finance: {
      // SUNSET FEATURE 2026-01-08: Bank Name, Bank Account No, Bank Account Holder Name
      // bankAccountHolderName: string;
      // bankAccountNo: string;
      // bankName: string;
      masterAccountNo: string;
      masterBankName: string;
      masterAccountHolderName: string;
      masterSwiftCode: string;
      paymentDueDate: string;
      attentionTo: string;
      // SUNSET FEATURE - Obsolete: cifNo
      // cifNo: string;
    };
    withdrawal: {
      ltv?: number;
      dailyCreditLtv?: number;
      monthlyCreditLtv?: number;
      monthlyWithdrawalLtv?: number;
      monthlyLimit?: number;
      limit: {
        min: number;
        max: number;
      };
      withdrawalProhibitedDayForNewlyBindedUser: number;
      withdrawalProhibitedDay: number;
    };
    locations: {
      createdBy: string;
      createdOn: number;
      id: string;
      location: {
        lat: number;
        long: number;
      };
      name: string;
      qr: {
        qrImage: string;
        qrImageTemplate: string;
      };
    }[];
    admin: {
      aid: string;
      loginId: string;
      role: string;
      actId: string;
      status: string;
    }[];
    // SUNSET FEATURE 2026-01-08: checkInMethod - commented out as part of feature sunset
    // checkInMethod: string[];
    scheduler?: boolean;
    earning?: string;
    status: string;
    createdOn: number;
    setting: {
      withdrawalCycleType: 'standard' | 'custom' | undefined;
      globalWithdrawalCycleId?: string;
      type?: string;
      actType?: string;
      // SUNSET FEATURE 2026-01-08: Employee Movement File & Days
      // employeeMovementFile: string;
      lastWithdrawalDate?: number;
      autoWithdrawalEnabled?: boolean;
      withdrawalDisabled?: boolean;
      // employeeMovementFileGenerationDays: string[];
      // SUNSET FEATURE 2026-01-08: Use OBA
      // useOba: boolean;
      customTemplate: {
        onboard: {
          file: string;
          source: string;
          fileList: { name: string; status: string; url: string }[];
          name: string;
        };
        onboardAgent: {
          file: string;
          source: string;
          fileList: { name: string; status: string; url: string }[];
          name: string;
        };
        update: {
          file: string;
          source: string;
          fileList: { name: string; status: string; url: string }[];
          name: string;
        };
      };
      commissionRequiresAuthentication: boolean;
      // SUNSET FEATURE: Obsolete
      // deductionFileGenerationDay: any[];
      // SUNSET FEATURE 2026-01-08: requiresDeductionFile - commented out as part of feature sunset
      // requiresDeductionFile: boolean | null;

      // SUNSET FEATURE - Obsolete
      // deductionInvoiceGenerationDate?: any[];
      invoiceFileRecipient: {
        to: string;
        cc: string;
      };

      // SUNSET FEATURE 2026-01-08: Employee Movement File Mailing List
      // employeeMovementFileRecipient: {
      //   to: string;
      //   cc: string;
      // };

      deductionFileRecipient: {
        to: string;
        cc: string;
      };
      withdrawalCycle: {
        tag: string;
        dateFrom: number;
        dateTo: number;
      }[];
      serviceProvider?: string;
      isFeeAbsorbed: boolean;
      isKickStartEarningEnabled: boolean;
      kickStartEarningAmount?: number;
      bulkImportApprovalFlag: boolean;
      bulkImportApprovalTypes?: Array<string>;
      creditBasedAccrualEnabled?: boolean;
      customWithdrawalSettings: {
        customWithdrawalSettingsEnabled: boolean;
        txnMaxWithdrawal: number;
        txnMinWithdrawal: number;
        dailyMaxWithdrawal: number;
        monthlyMaxWithdrawal: number;
        withdrawalFrequencyPerMonth?: number | null;
      };
      upfrontFeeDeductEnabled?: boolean;
      whiteLabel?: string;
      corporateCode?: string;
      deductionVarianceTrackingEnabled?: boolean;
      varianceRolloverEnabled?: boolean;
      excludeResignedEmployees?: boolean;
      successfulDeductionFileMapping?: {
        employeeId: string;
        amount: string;
      };
    };
    cycleHistoryData?: { id: string; tag: any; dateFrom: number; dateTo: number }[];
    cycles?: { tag: any; dateFrom: any; dateTo: any }[];
    cycle1?: { tag?: string; date?: string };
    cycle2?: { tag?: string; date?: string };
    location: {
      id: string;
      lat: number;
      long: number;
    };
    ableToImmediateCutOff?: boolean;
    cutoffCycleDateTo?: number;
  };
}

export const getEmployerInfo = (eid: string) => {
  return API.get()(`/api/employer/${eid}`);
};

export const useEmployerInfoData = (eid: string) => {
  return useQuery(['employer', eid], (): any => getEmployerInfo(eid), {
    enabled: !isUndefinedOrNullOrEmpty(eid),
    select: (response: IEmployerInfoResponse) => {
      const output = response.data;
      const res: ISharedEmployerInfoOrEmployerRequestInfoDataOutput = {
        ...output,
        companyInformation: {
          ...output.companyInformation,
          status: output.status,
          name: output.name,
          createdOn: output.createdOn,
          companyName: output.companyName,
          website: output.contactInformation?.website,
          foreignExchangeEnabled: output.companyInformation?.foreignExchangeEnabled ?? false,
          ...(output.companyInformation?.foreignExchangeProfile && {
            foreignExchangeProfile: output.companyInformation?.foreignExchangeProfile,
          }),
        },
        contactInformation: {
          ...output.contactInformation,
        },
        additionalInformation: {
          // SUNSET FEATURE 2026-01-08: Bank Name, Bank Account No, Bank Account Holder Name
          // bankName: output.finance?.bankName,
          // bankAccountNo: output.finance?.bankAccountNo,
          // bankAccountHolderName: output.finance?.bankAccountHolderName,
          masterAccountNo: output.finance?.masterAccountNo,
          masterBankName: output.finance?.masterBankName,
          masterAccountHolderName: output.finance?.masterAccountHolderName,
          masterSwiftCode: output.finance?.masterSwiftCode,
          paymentDueDate: output.finance?.paymentDueDate,
          attentionTo: output.finance?.attentionTo,
          // baseCountry: employerInfo?.companyInformation?.foreignExchangeProfile?.baseCountry ?? (countryCode || ''),
          // SUNSET FEATURE - Obsolete: cifNo
          // cifNo: output.finance.cifNo,
          // SUNSET FEATURE 2026-01-08: GST Registration No, Work Phone
          // gstRegistrationNo: output.companyInformation?.gstRegistrationNo,
          // workPhone: output.contactInformation?.workPhone,
          mobile: output.contactInformation?.mobile,
          email: output.contactInformation?.email,
          secondaryEmail: output.contactInformation?.secondaryEmail,
          mailingContactPerson: output.contactInformation?.mailing?.contactPerson,
          mailingAddressLine1: output.contactInformation?.mailing?.addressLine1,
          mailingAddressLine2: output.contactInformation?.mailing?.addressLine2,
          mailingCity: output.contactInformation?.mailing?.city,
          mailingState: output.contactInformation?.mailing?.state,
          mailingPostalCode: output.contactInformation?.mailing?.postalCode,
          mailingCountry: output.contactInformation?.mailing?.country,
          // useOba: output.setting?.useOba,
        },
        attachments: {
          ...output.attachments,
          owners: output.companyInformation?.owner,
        },
        setting: {
          ...output.setting,
          earning: output.earning,
          ltv: output.withdrawal?.ltv,
          customTemplate: {
            onboard: output.setting.customTemplate?.onboard,
            onboardAgent: output.setting.customTemplate?.onboardAgent,
            update: output.setting.customTemplate?.update,
          },
          dailyCreditLtv: output.withdrawal?.dailyCreditLtv,
          monthlyCreditLtv: output.withdrawal?.monthlyCreditLtv,
          monthlyWithdrawalLtv: output.withdrawal?.monthlyWithdrawalLtv,
          monthlyLimit: output.withdrawal?.monthlyLimit,
          autoWithdrawalEnabled: output.setting.autoWithdrawalEnabled,
          withdrawalDisabled: output.setting.withdrawalDisabled,
          // SUNSET FEATURE 2026-01-08: checkInMethod - commented out as part of feature sunset
          // checkInMethod: output.checkInMethod,
          scheduler: output.scheduler,
          // SUNSET FEATURE 2026-01-08: useCheckInOutFlag - commented out as part of feature sunset
          // useCheckInOutFlag: output.checkInMethod && output.checkInMethod.length > 0 ? '1' : '0',
          admin: output.admin,
          cycles: output.cycles ?? [],
          cycle1: output.cycle1,
          cycle2: output.cycle2,
          historyWithdrawalCycle: output.cycleHistoryData,
          withdrawalProhibitedDayForNewlyBindedUser: output.withdrawal.withdrawalProhibitedDayForNewlyBindedUser,
          withdrawalProhibitedDay: output.withdrawal.withdrawalProhibitedDay,
          bulkImportApprovalFlag: output.setting?.bulkImportApprovalFlag ?? true,
          bulkImportApprovalTypes:
            (output.setting?.bulkImportApprovalFlag ?? true) && output.setting.bulkImportApprovalTypes === undefined
              ? approvalBulkUploadTypesData.map((item) => item.value)
              : output.setting.bulkImportApprovalTypes ?? [],
          ableToImmediateCutOff: output.ableToImmediateCutOff,
          cutoffCycleDateTo: output.cutoffCycleDateTo,
          customWithdrawalSettingsEnabled: output.setting?.customWithdrawalSettings?.customWithdrawalSettingsEnabled,
          txnMaxWithdrawal: output.setting?.customWithdrawalSettings?.txnMaxWithdrawal,
          txnMinWithdrawal: output.setting?.customWithdrawalSettings?.txnMinWithdrawal,
          monthlyMaxWithdrawal: output.setting?.customWithdrawalSettings?.monthlyMaxWithdrawal,
          dailyMaxWithdrawal: output.setting?.customWithdrawalSettings?.dailyMaxWithdrawal,
          withdrawalFrequencyPerMonth: output.setting?.customWithdrawalSettings?.withdrawalFrequencyPerMonth,
          upfrontFeeDeductEnabled: output.setting?.upfrontFeeDeductEnabled ?? false,
          creditBasedAccrualEnabled: output.setting?.creditBasedAccrualEnabled ?? false,
          whiteLabel: output.setting?.whiteLabel,
          corporateCode: output.setting?.corporateCode,
          deductionVarianceTrackingEnabled: output.setting?.deductionVarianceTrackingEnabled ?? false,
          varianceRolloverEnabled: output.setting?.varianceRolloverEnabled ?? false,
          excludeResignedEmployees: output.setting?.excludeResignedEmployees ?? false,
        },
      };

      return res;
    },
  });
};
